module.exports = __webpack_public_path__ + "static/media/GA_Post_2018.12.08-4.6707566f.webp";